// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {actions as LogisticsAction} from '../duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';
import NiubizPayLinkConfig from '../components/paymentProviderConfigs/NiubizPayLinkConfig';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    error: state.paymentMethodConfig.error,
    isSaving: state.paymentMethodConfig.isSaving,
    paymentMethod: state.paymentMethodConfig.paymentMethod,
    currency: state.currency,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...LogisticsAction,
      },
      dispatch
    )
)(NiubizPayLinkConfig);
